// País activo seleccionado por el usuario (solo relevante si tiene ambos países).
// Se persiste en localStorage y se envía como header X-Country en cada petición.
// El backend valida el valor contra los países autorizados de la sesión.
export type CountrySel = "CO" | "PE" | "ALL";

const KEY = "tiger_country";

function read(): CountrySel {
  try {
    const v = localStorage.getItem(KEY);
    if (v === "CO" || v === "PE" || v === "ALL") return v;
  } catch { /* SSR / sin storage */ }
  return "ALL";
}

let current: CountrySel = read();

export function getCountry(): CountrySel { return current; }

export function setCountry(c: CountrySel): void {
  current = c;
  try { localStorage.setItem(KEY, c); } catch { /* noop */ }
}
